const FreeFalling = [
	"She's a good girl, loves her mama",
	'Loves Jesus and America too',
	"She's a good girl, is crazy 'bout Elvis",
	'Loves horses and her boyfriend too',
	'',
	"And it's a long day livin' in Reseda",
	"There's a freeway runnin' through the yard",
	"And I'm a bad boy, 'cause I don't even miss her",
	"I'm a bad boy for breakin' her heart",
	'',
	"Now I'm free",
	"Free fallin'",
	"Yeah, I'm free",
	"Free fallin'",
	'',
	"And all the vampires walkin' through the valley",
	'Move west down Ventura Boulevard (Ventura Boulevard)',
	"And all the bad boys are standin' in the shadows",
	'And the good girls are home with broken hearts',
	'',
	"And I'm free",
	"I'm free fallin'",
	"Yeah, I'm free",
	"Free fallin'",
	'',
	"Free fallin', now I'm free fallin', now I'm",
	"Free fallin', now I'm free fallin', now I'm",
	'',
	'I wanna glide down over Mulholland (oh-ah)',
	'I wanna write her name in the sky (oh-ah)',
	"I'm gonna free fall out into nothin' (oh-ah)",
	'Gonna leave this world for awhile (oh-ah)',
	'',
	"And I'm free (free fallin', now I'm free fallin', now I'm)",
	"Free fallin' (free fallin', now I'm free fallin', now I'm)",
	"Yeah, I'm free (free fallin', now I'm free fallin', now I'm)",
	"Free fallin' (free fallin', now I'm free fallin', now I'm)",
	'',
	"Free fallin', now I'm free fallin', now I'm",
	"Yeah, I'm free",
	"Free fallin'",
	'',
	"Oh! (Free fallin', now I'm free fallin', now I'm)",
	"Free fallin' (free fallin', now I'm free fallin', now I'm)",
	"And I'm free (free fallin', now I'm free fallin') oh! (Now I'm)",
	'',
	"Free fallin' (free fallin', now I'm free fallin', now I'm)",
	"Free fallin', now I'm free fallin', now I'm",
	"Free fallin' (free fallin', now I'm free...)",
];

export default FreeFalling;
